// @flow

import * as React from "react";
import ReactDOM from "react-dom";

import App from "./components/App/App";
import { HistoryContext } from "./components/HistoryContext/HistoryContext";
import browserHistory from "./../helpers/history";

export const renderApp = (rootElement: HTMLElement, callback?: () => void): ?React.Element<App> => {
	if(!rootElement)
		return null;

	const app = (
		<HistoryContext.Provider value={{history: browserHistory}}>
			<App initialPath={window.location.pathname + window.location.search}
				initialModel={window.viewModel} />
		</HistoryContext.Provider>
	);

	// $FlowIgnore
	return ReactDOM.hydrate(app, rootElement, callback);
};

export default renderApp;
